import { Github, Instagram, Linkedin, Twitter, Youtube } from "lucide-react";

const socialLinks = [
  {
    icon: <Github size={20} />,
    label: "GitHub",
    url: "https://github.com/thrivebot-discord",
    className: "hover:text-gray-600 dark:hover:text-gray-300",
  },
  {
    icon: <Linkedin size={20} />,
    label: "LinkedIn",
    url: "https://www.linkedin.com/in/thrivebot/",
    className: "hover:text-blue-600",
  },
  {
    icon: <Instagram size={20} />,
    label: "Instagram",
    url: "https://www.instagram.com/thrivebot.in/",
    className: "hover:text-pink-600",
  },
  {
    icon: <Twitter size={20} />,
    label: "X (Twitter)",
    url: "https://x.com/thrivebot_",
    className: "hover:text-gray-600",
  },
  {
    icon: <Youtube size={20} />,
    label: "YouTube",
    url: "https://www.youtube.com/@thrivebot",
    className: "hover:text-red-600",
  },
];

export const SocialLinks = () => {
  return (
    <div className="flex justify-center space-x-6 mb-6">
      {socialLinks.map(({ icon, label, url, className }) => (
        <a
          key={label}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={`transition-colors ${className}`}
          aria-label={label}
        >
          {icon}
        </a>
      ))}
    </div>
  );
};